import VerifiedBadge from "@/components/VerifiedBadge";

// Blue "Verified" mark on a live tile, placed beside LiveKit's name bar (bottom-left). Visual only.
export default function StageTileVerified({ participant }) {
  let meta = {};
  try { meta = JSON.parse(participant?.metadata || "{}") || {}; } catch { meta = {}; }
  if (!meta.is_verified) return null;
  return (
    <div className="absolute bottom-1.5 right-1.5 z-[6] rounded-full bg-black/55 px-1.5 py-0.5" data-testid={`live-tile-verified-${participant?.identity}`}>
      <VerifiedBadge show size="sm" />
    </div>
  );
}
